/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type Notifications_viewer$ref = any;
export type NotificationsRefetchQueryVariables = {
    readonly first?: number | null;
    readonly fetchNotifications: boolean;
};
export type NotificationsRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": Notifications_viewer$ref;
    } | null;
};
export type NotificationsRefetchQuery = {
    readonly response: NotificationsRefetchQueryResponse;
    readonly variables: NotificationsRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchNotifications",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "NotificationsRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Notifications_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "fetchNotifications",
                                    "variableName": "fetchNotifications"
                                },
                                (v1 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "NotificationsRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": "regInfo",
                            "name": "regionalInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RegionalInfo",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "countryCode",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v2 /*: any*/)
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isAutomatedOfferNotificationDisabled",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "disableAutomatedOfferBellNotification"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
                        },
                        (v2 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchNotifications",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conversations",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": "showUnreadOnly"
                                        },
                                        (v1 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "notifications",
                                            "value": true
                                        }
                                    ],
                                    "concreteType": "ConversationConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConversationEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Conversation",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "serviceId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "hasUnreadMessageForMember",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "apiType",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "inboxImage",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "item",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Item",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "title",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "latestMessage",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "latestMessageReceivedAt",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "NotificationsRefetchQuery",
            "id": "ferrum/232.0.0-2019-09-10T19:14:50.345Z/NotificationsRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c90972fb1ab1c982607d2a47db790d4e';
export default node;
